(function () {
    'use strict';

    angular
        .module('franchisee-portal.directives')
        .directive('sidebar', Sidebar)

    /** @ngInject */
    function Sidebar($rootScope, $timeout, $window, $state, AuthenticationService, HelperService, PATHS, ROUTES, DATA_EVENTS) {
        function SidebarController($scope) {
            const vm = this;

            vm.getClusterPerformanceCard = () => {
                const clusterPerformance = vm.loggedUserData.ClusterPerformance;

                if (clusterPerformance.Id == 1)
                    return `${ROUTES.CENTRAL_CONTAS}/app/dist/images/cluster-cards/bronze.png`;
                else if (clusterPerformance.Id == 2)
                    return `${ROUTES.CENTRAL_CONTAS}/app/dist/images/cluster-cards/silver.png`;
                else if (clusterPerformance.Id == 3)
                    return `${ROUTES.CENTRAL_CONTAS}/app/dist/images/cluster-cards/gold.png`;
                else if (clusterPerformance.Id == 4)
                    return `${ROUTES.CENTRAL_CONTAS}/app/dist/images/cluster-cards/diamond.png`;
            }

            vm.logout = () => AuthenticationService.logout(true);

            vm.isExternalUrl = url => {
                return url.includes('http');
            }

            vm.toggleMenuOpen = () => {
                vm.menuOpen = !vm.menuOpen;

                $rootScope.menuOpen = vm.menuOpen;

                localStorage.setItem('SSOMenuOpen', vm.menuOpen);
            }

            vm.handleSubmodule = module => {
                if (!module.ParentModuleId) {
                    if (!module.IsOpen) {
                        vm.modules.forEach(mod => {
                            mod.IsOpen = false;
                        });

                        module.IsOpen = true;
                    } else {
                        module.IsOpen = false;
                    }
                }
            }

            vm.getState = module => {
                if (module.Module1 && module.Module1.length)
                    return 'null';

                let state = $state.get().find(state => {
                    if (!state.url)
                        return false;

                    return state.url.includes(module.Url);
                });

                return state ? state.name : 'app.home';
            }

            vm.isActiveMenu = module => {
                const urlSplitted = $state.current.url.split('/');

                return module.Url == `/${urlSplitted[1]}`;
            }

            vm.getPersonImage = () => {
                if (vm.loggedUserData.Image)
                    return `${ROUTES.CENTRAL_CONTAS}api/images/res/150/150/person/${vm.loggedUserData.ExternalId}/${vm.loggedUserData.Image}`;

                return `${ROUTES.CENTRAL_CONTAS}api/images/res/100/100/placeholder.jpg`;
            }

            let removeWatchUnit = $rootScope.$on(DATA_EVENTS.SELECTED_UNIT_CHANGE, () => {
                init();
            })

            let removeWatchWindow = angular.element($window).on('resize', () => {
                $rootScope.isMobile = HelperService.isScreenSmaller(991);

                $timeout(() => {
                    vm.isMobile = $rootScope.isMobile;
                });
            });

            $scope.$on('$destroy', () => {
                removeWatchUnit();
                removeWatchWindow();
            });

            init();

            function orderMenu(a, b) {
                if (a.Ordenation < b.Ordenation)
                    return -1;

                if (a.Ordenation > b.Ordenation)
                    return 1;

                return 0;
            }

            function setFirstRunCurrentModule() {
                const currentStateUrl = $state.current.url;
                let currentModule = vm.modules.find(mod => (mod.Url == currentStateUrl));

                if (!currentModule) {
                    vm.modules.forEach(mod => {
                        if (mod.Module1 && mod.Module1.length && mod.Module1.find(subMod => subMod.Url == currentStateUrl)) {
                            currentModule = mod;
                        }
                    })
                }

                if (currentModule) {
                    currentModule.IsOpen = true;
                }
            }

            function init() {
                vm.ROUTES = ROUTES;
                vm.isMobile = $rootScope.isMobile;
                vm.loggedUserData = AuthenticationService.getUserData();

                const lsValue = localStorage.getItem('SSOMenuOpen');
                let isMenuOpen = true;

                if (lsValue == 'false' || lsValue == false || vm.isMobile)
                    isMenuOpen = false;

                $timeout(() => {
                    vm.menuOpen = isMenuOpen;
                    $rootScope.menuOpen = isMenuOpen;

                    $.fn.scrollbar && $('.scrollable').scrollbar({
                        ignoreOverlay: false
                    });

                    const modules = AuthenticationService.getModules().sort(orderMenu);

                    vm.modules = modules;

                    setFirstRunCurrentModule();
                })
            }
        }

        return {
            bindToController: true,
            controller: SidebarController,
            controllerAs: 'vm',
            restrict: 'AE',
            templateUrl: `${PATHS.PHYSICAL}/directives/sidebar/sidebar.html`,
            scope: {}
        }
    }
}());